<template>
  <div>
    <div class="text-center" v-if="new_address">
      <!--autocompletado de google-->
      <google-places-autocomplete
        @resultChanged="placeDetail => getAddressData(placeDetail)"
      >
        <div slot="input" slot-scope="{ context, events, actions }">
          <input
            v-model="context.input"
            @focus="events.inputHasReceivedFocus"
            @input="events.inputHasChanged"
            @keydown.enter.prevent="actions.selectItemFromList"
            @keydown.down.prevent="actions.shiftResultsSelection"
            @keydown.up.prevent="actions.unshiftResultsSelection"
            type="search"
            id="locationInput"
            placeholder="Ingresa tu dirección completa"
            class="input-nv"
          />
          <div class="text-right mt-1">
            <img
              class="powered_by_google"
              src="@/assets/store/powered_by_google.png"
              alt="powered by google"
            >
          </div>

        </div>

      </google-places-autocomplete>
    </div>
    <!--formulario registro nueva direccion-->
    <div class="mt-5" v-if="address.latitude && address.longitude && valid_address">

      <form data-vv-scope="form-address">
        <div v-if="show_input_email" class="row">
          <div class="col col-12">
            <div class="form-group">
              <label class="label-nv" for="name">EMAIL DE CONTACTO</label>
              <input
                v-model="address.contact_email"
                class="input-nv"
                type="email"
                name="email" v-validate="'email'" data-vv-as="Correo"
              >
              <br>
              <span v-show="errors.has('form-address.email')" class="text-danger mt-2">
                {{ errors.first("form-address.email") }}
              </span>
            </div>
          </div>
        </div>

        <label class="label-nv" for="name">DIRECCIÓN DE ENVÍO</label>
        <div class="row mb-5">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="name">Nombre *</label><br>
              <input v-model="address.name" name="name" v-validate="new_address ? 'required' : ''" data-vv-as="Nombre" class="input-nv" id="name">
              <br>
              <span v-show="errors.has('form-address.name')" class="text-danger mt-2">
                {{ errors.first("form-address.name") }}
              </span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="lastname">Apellido *</label><br>
              <input v-model="address.lastname" name="lastname" v-validate="new_address ? 'required' : ''" data-vv-as="Apellido" class="input-nv" id="lastname">
              <br>
              <span v-show="errors.has('form-address.lastname')" class="text-danger mt-2">
                {{ errors.first("form-address.lastname") }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="street">Calle *</label><br>
              <input
                :disabled="fields_disabled.street"
                v-model="address.street"
                name="street"
                v-validate="new_address ? 'required' : ''"
                data-vv-as="Calle"
                class="input-nv"
                id="street"
              >
              <br>
              <span v-show="errors.has('form-address.street')" class="text-danger mt-2">
                {{ errors.first("form-address.street") }}
              </span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="ext">No. exterior *</label><br>
              <input
                :disabled="fields_disabled.no_outside"
                v-model="address.no_outside"
                name="no_exterior"
                v-validate="new_address ? 'required' : ''"
                data-vv-as="No. exterior"
                class="input-nv"
                id="ext"
              >
              <br>
              <span v-show="errors.has('form-address.no_exterior')" class="text-danger mt-2">
                {{ errors.first("form-address.no_exterior") }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="int">No. interior *</label>
              <input
                v-model="address.no_inside"
                name="no_inside"
                v-validate="new_address ? 'required' : ''"
                data-vv-as="No. interior"
                class="input-nv"
                id="int"
              >
              <br>
              <span v-show="errors.has('form-address.no_inside')" class="text-danger mt-2">
                {{ errors.first("form-address.no_inside") }}
              </span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="colony">Colonia *</label><br>
              <input
                :disabled="fields_disabled.colony"
                v-model="address.colony"
                name="colony"
                v-validate="new_address ? 'required' : ''"
                data-vv-as="Colonia"
                class="input-nv"
                id="colony"
              >
              <br>
              <span v-show="errors.has('form-address.colony')" class="text-danger mt-2">
                {{ errors.first("form-address.colony") }}
              </span>
            </div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="zip">* Código Postal</label>
              <input
                :disabled="fields_disabled.zip"
                name="zip"
                v-validate="new_address ? 'required' : ''"
                data-vv-as="Código postal"
                v-model="address.zip"
                class="input-nv"
                id="zip"
              >
              <br>
              <span v-show="errors.has('form-address.zip')" class="text-danger mt-2">
                {{ errors.first("form-address.zip") }}
              </span>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="city">Ciudad *</label><br>
              <input
                :disabled="fields_disabled.city"
                v-model="address.city"
                name="city"
                v-validate="new_address ? 'required' : ''"
                data-vv-as="Ciudad"
                class="input-nv"
                id="city"
              >
              <br>
              <span v-show="errors.has('form-address.city')" class="text-danger mt-2">
                {{ errors.first("form-address.city") }}
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="form-group text-center">
              <label class="label-nv" for="phone">Teléfono *</label>
              <input
                v-model="address.phone"
                name="phone"
                v-validate="'required|numeric|digits:10'"
                data-vv-as="Teléfono"
                class="input-nv"
                id="phone"
                v-mask="mask"
              >
              <br>
              <span v-show="errors.has('form-address.phone')" class="text-danger mt-2">
                {{ errors.first("form-address.phone") }}
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-left">
            <v-checkbox
              v-if="!show_input_email"
              v-model="address.primary_address"
              label="Guardar como dirección principal"
              color="primary"
            ></v-checkbox>
            <v-checkbox
              v-else
              v-model="address.save_info"
              label="Guardar mi información y consultar más rápidamente la próxima vez"
              color="primary"
            ></v-checkbox>

            <v-btn
              text
              color="primary"
              class="mt-5"
              @click="() => $router.push('/checkout')"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              Volver a mi compra
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col text-right">
            <v-btn
              @click="goShipping()"
              color="primary"
              class="nv-btn nv-btn-large nv-btn-hover"
              :loading="loading"
              elevation="0"
            >
              CONTINUAR A ENVÍOS
            </v-btn>
          </div>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
import { GooglePlacesAutocomplete } from 'vue-better-google-places-autocomplete'

export default {
  props: ['address', 'show_input_email', 'new_address', 'valid_address'],
  components: { GooglePlacesAutocomplete },
  data() {
    return {
      mask: [/\d/, /\d/, '', /\d/, /\d/, /\d/, /\d/, '', /\d/, /\d/, /\d/, /\d/],
      loading: false,
      fields_disabled: {
        street: false,
        no_outside: false,
        colony: false,
        zip: false,
        city: false
      },

      zip: '',
      city: '',
      outside: '',
      street: '',
      colony: ''
    }
  },
  computed: {
    changeAddres() {
      return this.address
    }
  },
  watch: {
    changeAddres() {
      this.disabledFieldsForm()
    }
  },
  methods: {
    goShipping() {
      if (this.show_input_email && !this.address.contact_email) {
        this.$swal('Debes ingresar un email de contacto', '', 'warning')
        return false
      }
      this.$validator.validateAll('form-address').then(async result => {
        if (result) {
          this.$emit('changeStep', 'shipping_data', 1)
        } else {
          this.$swal(this.errors.items[0].msg, '', 'warning')
          return false
        }
      })
    },
    getAddressData(addressData) {
      console.log(addressData)
      console.log(addressData.geometry.location.lat(),addressData.geometry.location.lng())

      this.zip = ''
      this.city = ''
      this.outside = ''
      this.street = ''
      this.colony = ''

      addressData.address_components.forEach(i => {
        if (i.types.length) {
          console.log(i.long_name, i.types)
          if (i.types.indexOf('postal_code') > -1) {
            this.zip = i.long_name
          }
          if (i.types.indexOf('locality') > -1) {
            this.city = i.long_name
          }
          if (i.types.indexOf('street_number') > -1) {
            this.outside = i.long_name
          }
          if (i.types.indexOf('route') > -1) {
            this.street = i.long_name
          }
          if (i.types.indexOf('sublocality_level_1') > -1 || i.types.indexOf('neighborhood') > -1) {
            this.colony = i.long_name
          }
        }
      })
      this.address.zip = this.zip
      this.address.city = this.city
      this.address.no_outside = this.outside
      this.address.street = this.street
      this.address.colony = this.colony
      this.address.latitude = addressData.geometry.location.lat()
      this.address.longitude = addressData.geometry.location.lng()
      this.address.full_address = addressData.formatted_address

      this.disabledFieldsForm()

      if (!this.validateAddressEntered()) {
        this.address.latitude = ''
        this.address.longitude = ''
        this.address.full_address = ''
        this.$swal(
          'La dirección ingresada no es valida, por favor ingresa tu dirección completa',
          'Considera colocar la calle, número de exterior y la colonia para una mejor búsqueda',
          'warning'
        )
        return false
      }/* else {
        this.$emit('validateLocation', {
          lat: addressData.geometry.location.lat(),
          lng: addressData.geometry.location.lng(),
          address: this.address
        })
      }*/

    },
    validateAddressEntered() {
      if (this.address.city == '' || this.address.street == '' || this.address.colony == '') {
        return false
      } else {
        return true
      }
    },
    disabledFieldsForm() {
      if (this.address.zip != '') {
        this.fields_disabled.zip = true
      } else {
        this.fields_disabled.zip = false
      }
      if (this.address.city != '') {
        this.fields_disabled.city = true
      } else {
        this.fields_disabled.city = false
      }
      if (this.address.no_outside != '') {
        this.fields_disabled.no_outside = true
      } else {
        this.fields_disabled.no_outside = false
      }
      if (this.address.street != '') {
        this.fields_disabled.street = true
      } else {
        this.fields_disabled.street = false
      }
      if (this.address.colony != '') {
        this.fields_disabled.colony = true
      } else {
        this.fields_disabled.colony = false
      }

      this.fields_disabled = {...this.fields_disabled}
    }
    /*
    usedCurrentLocation() {
      navigator.geolocation.getCurrentPosition(
				(position) => {
          this.address.latitude = position.coords.latitude
          this.address.longitude = position.coords.longitude
          this.$emit('validateLocation', {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            address: this.address
          })
				},
				() => {
					alert('Position could not be determined.');
				}, { enableHighAccuracy: true }
      );
    }*/
  }
}
</script>
